import { sendPort } from "./50rdcsm1";

// const apiNames = {
var APIURL = {
  test: {
    list: process.env.VUE_APP_PROXY_API + '',
    add: process.env.VUE_APP_PROXY_API + '',
    update: process.env.VUE_APP_PROXY_API + '',
    delete: process.env.VUE_APP_PROXY_API + '',
    info: process.env.VUE_APP_PROXY_API + ''
  },
  account: {
    password: {
      update: process.env.VUE_APP_PROXY_API + '/user/pwd',
      reset: process.env.VUE_APP_PROXY_API + '/sysUser'
    },
    user: {
      update: process.env.VUE_APP_PROXY_API + '/sysUser/profile',
      info: process.env.VUE_APP_PROXY_API + '/user/profile'
    },
    status: {
      update: process.env.VUE_APP_PROXY_API + '/sysUser'
    },
    userTemplate: {
      download: process.env.VUE_APP_PROXY_API + '/sysUser/importTemplate'
    }
  },
  alarm: {
    // 告警
    list: process.env.VUE_APP_PROXY_API + '/alarm/list',
    add: process.env.VUE_APP_PROXY_API + '/alarm/add',
    update: process.env.VUE_APP_PROXY_API + '/alarm/update',
    info: process.env.VUE_APP_PROXY_API + '/alarm/info'
  },
  alarmSet: {
    // 告警设置
    list: process.env.VUE_APP_PROXY_API + '/alarm/setList',
    add: process.env.VUE_APP_PROXY_API + '/alarm/addSet',
    update: process.env.VUE_APP_PROXY_API + '/alarm/updateSet',
    delete: process.env.VUE_APP_PROXY_API + '/alarm/delData'
  },
  dept: {
    list: process.env.VUE_APP_PROXY_API + '/deptList',
    info: process.env.VUE_APP_PROXY_API + "/dept/:id",
    tree: process.env.VUE_APP_PROXY_API + '/enterpriseDeptTree',
    treeByRole: process.env.VUE_APP_PROXY_API + '/roleDeptTreeselect/:id',
    add: process.env.VUE_APP_PROXY_API + '/dept',
    update: process.env.VUE_APP_PROXY_API + '/dept',
    delete: process.env.VUE_APP_PROXY_API + '/dept/:id',
    sort: process.env.VUE_APP_PROXY_API + '/dept/sort'
  },
  // 派单
  dispatch: {
    list: process.env.VUE_APP_PROXY_API + '/dispatch/myDispatchList',
    add: process.env.VUE_APP_PROXY_API + '/dispatch/addDistributeLeaflets',
    update: process.env.VUE_APP_PROXY_API + '/dispatch/updateDistributeLeaflets',
    delete: process.env.VUE_APP_PROXY_API + '/policy/delData',
    info: process.env.VUE_APP_PROXY_API + '/policy/getData'
  },
  // 工单
  workOrder: {
    add: process.env.VUE_APP_PROXY_API2 + '/sms/send/alarm',
    list: process.env.VUE_APP_PROXY_API2 + '/sms/log/list'
  },
  enterprise: {
    all: process.env.VUE_APP_PROXY_API + '/enterpriseAll',
    // (系统管理->用户管理->获取单位数据所有数据)
    list: process.env.VUE_APP_PROXY_API + '/enterpriseList',
    // （平台管理->客户管理->分页查询）
    info: process.env.VUE_APP_PROXY_API + '/enterpriseInfo',
    // （平台管理->客户管理->修改）
    add: process.env.VUE_APP_PROXY_API + '/enterpriseAdd',
    // (平台管理->客户管理->新增)
    update: process.env.VUE_APP_PROXY_API + '/enterpriseUpdate',
    // (平台管理->客户管理->修改)
    delete: process.env.VUE_APP_PROXY_API + '/enterpriseDel' // (平台管理->客户管理->删除）
  },

  heart: {
    send: {
      all: process.env.VUE_APP_PROXY_API + '/sendHeartAll',
      one: process.env.VUE_APP_PROXY_API + '/sendHeartByTerminalId'
    },
    // ############################新添加  (上海五零所协议单灯)########################################
    rdcsm50: {
      list: process.env.VUE_APP_PROXY_API + '/rdcsm/50/terminal/list',
      // 单灯设备列表
      delete: process.env.VUE_APP_PROXY_API + '/rdcsm/50/terminal/del',
      // 删除单灯设备
      info: process.env.VUE_APP_PROXY_API + '/rdcsm/50/terminal/info',
      // 单灯设备详情  3>>
      sendAttribute: process.env.VUE_APP_PROXY_API + '/rdcsm/50/send/attribute/query',
      // 查看设备属性 写卡信息进入数据库 3>>
      update: process.env.VUE_APP_PROXY_API + '/rdcsm/50/terminal/update',
      // 修改单灯基本信息
      sendHeartBy50: process.env.VUE_APP_PROXY_API + '/terminal/heart/test',
      // 招测
      openlight: process.env.VUE_APP_PROXY_API + '/rdcsm/50/send/open/light',
      // 开灯
      closelight: process.env.VUE_APP_PROXY_API + '/rdcsm/50/send/close/light',
      // 关灯
      dimmerlight: process.env.VUE_APP_PROXY_API + '/rdcsm/50/send/light/dimmer',
      // 调光
      batchOpenLight: process.env.VUE_APP_PROXY_API + '/rdcsm/50/send/batch/open/light',
      // 批量开灯
      batchCloseLight: process.env.VUE_APP_PROXY_API + '/rdcsm/50/send/batch/close/light',
      // 批量关灯
      batchDimmerLight: process.env.VUE_APP_PROXY_API + '/rdcsm/50/send/batch/light/dimmer',
      // 批量调光
      clearSiglePlan: process.env.VUE_APP_PROXY_API + '/rdcsm/50/send/clear',
      // 清除原方案
      sendSingleTimeSet: process.env.VUE_APP_PROXY_API + '/rdcsm/50/send/clock/query',
      // 请求时钟
      clockTimeData: process.env.VUE_APP_PROXY_API + '/rdcsm/50/terminal/clock/time',
      // 时钟数据
      addLocalControl: process.env.VUE_APP_PROXY_API + '/rdcsm/50/local/control/set/add',
      // 新增本地控制方案
      writeLocalControl: process.env.VUE_APP_PROXY_API + '/rdcsm/50/send/local/control/query',
      // 写本地控制进入数据库 1>>
      localControlList: process.env.VUE_APP_PROXY_API + '/terminal/rdcsm/50/local/ctr/list',
      // 本地控制返回列表 1>>
      addControlList: process.env.VUE_APP_PROXY_API + '/rdcsm/50/local/control/set/list',
      // 新增本地控制方案列表
      deleteControl: process.env.VUE_APP_PROXY_API + '/rdcsm/50/local/control/set/delete',
      // 删除本地控制方案
      localControlListInfo: process.env.VUE_APP_PROXY_API + '/rdcsm/50/local/control/set/info',
      // 本地控制方案详情
      localControlStatus: process.env.VUE_APP_PROXY_API + '/rdcsm/50/local/control/set/status/update',
      // 本地控制方案状态
      updateLocalControl: process.env.VUE_APP_PROXY_API + '/rdcsm/50/local/control/set/update',
      // 修改本地控制方案
      bindPlan: process.env.VUE_APP_PROXY_API + '/rdcsm/50/local/control/bind/add',
      // 设备绑定方案
      bindPlanInfo: process.env.VUE_APP_PROXY_API + '/rdcsm/50/local/control/bind/info',
      // 设备绑定方案详情
      operationLogList: process.env.VUE_APP_PROXY_API + '/rdcsm/50/opt/log/list',
      // 操作日志列表
      operationLogInfo: process.env.VUE_APP_PROXY_API + '/rdcsm/50/opt/log/info',
      // 操作日志列表详情
      operationLogupdate: process.env.VUE_APP_PROXY_API + '/rdcsm/50/opt/log/update',
      // 修改操作日志操作状态
      sendParamsSet: process.env.VUE_APP_PROXY_API + '/rdcsm/50/send/param/set',
      // 发送参数指令设置 2>>
      writeParamsSet: process.env.VUE_APP_PROXY_API + '/rdcsm/50/send/param/query',
      // 写入查询参数设置进入数据库 2>>
      paramsSetInfo: process.env.VUE_APP_PROXY_API + '/rdcsm/50/params/set/log/info',
      // 参数指令设置详情 2>>
      reportLogList: process.env.VUE_APP_PROXY_API + '/rdcsm/50/report/log/list',
      // 设备上报列表历史
      reportLogInfo: process.env.VUE_APP_PROXY_API + '/rdcsm/50/report/log/info',
      // 设备上报列表历史详情
      sendPort: process.env.VUE_APP_PROXY_API + '/terminal/ip/set',
      // 主站IP地址及端口设置
      sendPortInfo: process.env.VUE_APP_PROXY_API + '/terminal/ip/query',
      // 请求主站IP地址及端口
      updateStatus: process.env.VUE_APP_PROXY_API + '/rdcsm/50/terminal/status/update',
      // 修改设备状态--加了关联道路
      addRoad: process.env.VUE_APP_PROXY_API2 + '/road/set/add',
      // 添加道路
      roadList: process.env.VUE_APP_PROXY_API2 + '/road/set/list',
      // 道路列表
      updateRoad: process.env.VUE_APP_PROXY_API2 + '/road/set/update',
      // 道路修改
      deleteRoad: process.env.VUE_APP_PROXY_API2 + '/road/set/del',
      // 道路删除
      roadInfo: process.env.VUE_APP_PROXY_API2 + '/road/set/info',
      // 道路详情
      addSingle50: process.env.VUE_APP_PROXY_API + '/rdcsm/50/terminal/add',
      // 新增单灯设备
      eventData: process.env.VUE_APP_PROXY_API + '/rdcsm/50/event/data/list',
      //单灯开关灯、调光状态变化及漏电告警
      offlineOver24h: process.env.VUE_APP_PROXY_API + '/rdcsm/50/terminal/offlineOver24h/list',
      //大于24小时离线的单灯设备
      // ------------------------以下数据可视化-------------------------------------
      countStatistics: process.env.VUE_APP_PROXY_API2 + '/terminal/statistics',
      //设备数量统计
      electric50: process.env.VUE_APP_PROXY_API + '/rdcsm/50/total/electric/statistics',
      //单灯能耗  day、week、month
      powerRdc4m: process.env.VUE_APP_PROXY_API + '/rdc4m/total/power/statistics' //箱体功率  day、week、month
    },

    single: {
      list: process.env.VUE_APP_PROXY_API + '/rdcsm/heartList',
      // 虹友老版本单灯--设备列表
      info: process.env.VUE_APP_PROXY_API + '/rdcsm/heartInfo' // 虹友老版本单灯--设备详情
    },

    integrate: {
      list: process.env.VUE_APP_PROXY_API + '/heartList',
      // list: process.env.VUE_APP_PROXY_API2 + '/terminal/rdc4m/list',
      info: process.env.VUE_APP_PROXY_API + '/heartInfo'
    }
  },
  heartLog: {
    single: {
      list: process.env.VUE_APP_PROXY_API + '/rdcsm/hearttestLog',
      info: process.env.VUE_APP_PROXY_API + '/rdcsm/hearttestLogInfo'
    },
    integrate: {
      list: process.env.VUE_APP_PROXY_API + '/hearttestLog',
      info: process.env.VUE_APP_PROXY_API + '/hearttestLogInfo'
    }
  },
  policy: {
    list: process.env.VUE_APP_PROXY_API + '/policy/pageList',
    add: process.env.VUE_APP_PROXY_API + '/policy/addData',
    update: process.env.VUE_APP_PROXY_API + '/policy/updateData',
    delete: process.env.VUE_APP_PROXY_API + '/policy/delData',
    info: process.env.VUE_APP_PROXY_API + '/policy/getData'
  },
  policyTemplate: {
    rdcsm: {
      list: process.env.VUE_APP_PROXY_API + '/policy/template/list/rdcsm',
      add: process.env.VUE_APP_PROXY_API + '/policy/template/add/rdcsm',
      update: process.env.VUE_APP_PROXY_API + '/policy/template/modify/rdcsm',
      delete: process.env.VUE_APP_PROXY_API + '/policy/template/delete/rdcsm',
      info: process.env.VUE_APP_PROXY_API + '/policy/template/info/rdcsm'
    },
    rdc4m: {
      list: process.env.VUE_APP_PROXY_API + '/policy/template/list/rdc4m',
      add: process.env.VUE_APP_PROXY_API + '/policy/template/add/rdc4m',
      update: process.env.VUE_APP_PROXY_API + '/policy/template/modify/rdc4m',
      delete: process.env.VUE_APP_PROXY_API + '/policy/template/delete/rdc4m',
      info: process.env.VUE_APP_PROXY_API + '/policy/template/info/rdc4m'
    }
  },
  query: {
    terminal: process.env.VUE_APP_PROXY_API + '/query/terminals',
    template: process.env.VUE_APP_PROXY_API + '/query/template'
  },
  schedule: {
    list: process.env.VUE_APP_PROXY_API + '/plan/list',
    update: process.env.VUE_APP_PROXY_API + '/plan/add'
  },
  scheduleEmergency: {
    update: process.env.VUE_APP_PROXY_API + '/plan/emergency/add',
    info: process.env.VUE_APP_PROXY_API + '/plan/emergency/query'
  },
  setting: {
    manauto: {
      info: process.env.VUE_APP_PROXY_API + '/queryManautoData'
    }
  },
  sysUser: {
    list: process.env.VUE_APP_PROXY_API + '/sysUserList',
    info: process.env.VUE_APP_PROXY_API + '/sysUser/:userId',
    // init: process.env.VUE_APP_PROXY_API + '/sysUser/',
    init: process.env.VUE_APP_PROXY_API + '/sysUser',
    add: process.env.VUE_APP_PROXY_API + '/sysUser',
    update: process.env.VUE_APP_PROXY_API + '/sysUser',
    delete: process.env.VUE_APP_PROXY_API + '/sysUser/:userId',
    export: process.env.VUE_APP_PROXY_API + '/sysUser/export'
  },
  terminal: {
    list: process.env.VUE_APP_PROXY_API + '/terminalList',
    add: process.env.VUE_APP_PROXY_API + '/addterminal',
    update: process.env.VUE_APP_PROXY_API + '/editterminal',
    delete: process.env.VUE_APP_PROXY_API + '/delterminal',
    // 删除(注册)设备
    deviceDelete: process.env.VUE_APP_PROXY_API2 + '/terminal/inventory/delete',
    // 删除(车间测试)设备--陈添加
    info: process.env.VUE_APP_PROXY_API + '/terminalInfo',
    inventory: process.env.VUE_APP_PROXY_API + '/terminal/inventory/list' // 设备库存/设备仓储列表
  },

  user: {
    login: '/api/login',
    logout: process.env.VUE_APP_PROXY_API + '/logout',
    refreshtoken: '/refreshtoken',
    info: process.env.VUE_APP_PROXY_API + '/getinfo',
    captcha: process.env.VUE_APP_PROXY_API + '/getCaptcha'
  },
  userAvatar: {
    upload: process.env.VUE_APP_PROXY_API + '/user/avatar'
  },
  task: {
    exec: {
      rdcsm: {
        relay: process.env.VUE_APP_PROXY_API + '/rdcsm/relayExec/info',
        manauto: process.env.VUE_APP_PROXY_API + '/rdcsm/manautoExec/info'
      },
      rdc4m: {
        relay: process.env.VUE_APP_PROXY_API + '/rdc4m/relayExec/info',
        manauto: process.env.VUE_APP_PROXY_API + '/rdc4m/manautoExec/info'
      }
    }
  }
};
export default APIURL;